import React from 'react'
import Container from './components/Container/Container'

const App = () => <Container />

export default App
